import React, { useState, useEffect } from 'react';
import Notice from './Notice';
import { makeStyles } from '@material-ui/core';
import { getNotice } from '../../functions/notice';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        // flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        width: '900px',
        margin: '20px 50px',
        "@media (max-width: 770px)": {
            width: "100%",
            margin: '20px 0px'
        },
    }
}));
const ListNotice = () => {

    const styles = useStyles();

    const [notices, setNotices] = useState([{ title: "", content: "", date: "", _id: "", author: "", image_urls: [] }]);

    useEffect(() => {

        getNotice().then(res => {
            console.log(res);
            setNotices([...res.reverse()]);
        }
        ).catch(err => {
            console.log(err);
        });

        return;

    }, [])

    return (
        <>
            <div>
                <h2>
                    공지 게시판
                </h2>
            </div>
            <div className={styles.container}>
                {
                    notices.length === 0 ?
                        <CircularProgress /> :
                        <>
                            {notices.map((item, index) =>
                                <Notice
                                    key={index}
                                    title={item.title}
                                    content={item.content}
                                    date={moment(item.date).format('YYYY.MM.DD')}
                                    image_urls={item.image_urls}
                                    author={item.author}

                                />
                            )}
                        </>
                }
            </div>

        </>
    );
};

export default ListNotice;